import { Navigate, useLocation, useParams } from 'react-router-dom';
import { travelCariHref, type TravelCariSource } from '@polatkan/api/travel-cari';

/** Compatibility only: there is no independent customer or partner workspace. */
export function LegacyTravelCariRedirect({ source }: { source: TravelCariSource }) {
  const { id } = useParams();
  const { search, hash } = useLocation();
  if (id) return <Navigate replace to={`${travelCariHref(source, id)}${search}${hash}`} />;
  const params = new URLSearchParams(search);
  params.set('source', source);
  return <Navigate replace to={`/travel/cari?${params}${hash}`} />;
}
